module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point04_06_activity-0926945337f07738ae7d4418aea2a014.jpg";